import type { ReactNode } from 'react';
import { createContext, useContext, useState } from 'react';
// avoid circular reference
import type { AlertProps } from '../components/Alert';
import { Alert } from '../components/Alert';

interface AlertContextProps {
  setSuccess: (msg: string) => void;
  setError: (msg: string) => void;
}

const AlertContext = createContext<AlertContextProps>({
  setError: () => {},
  setSuccess: () => {},
});

function AlertProvider(props: { children: ReactNode }) {
  const [msg, setMsg] = useState<Pick<AlertProps, 'message' | 'variant'>>({
    message: '',
    variant: 'success',
  });
  const [open, setOpen] = useState(false);

  return (
    <AlertContext.Provider
      value={{
        setSuccess: (m) => {
          setMsg({ variant: 'success', message: m });
          setOpen(true);
        },
        setError: (m) => {
          setMsg({ variant: 'error', message: m });
          setOpen(true);
        },
      }}
    >
      {props.children}
      <Alert {...msg} open={open} onClose={() => setOpen(false)} />
    </AlertContext.Provider>
  );
}

function useAlert() {
  return useContext(AlertContext);
}

export { AlertProvider, useAlert };
